import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
  }

  apply(event) {
    event.preventDefault()
    
    const currentTab = this.tabTargets.find(tab => 
      !tab.classList.contains('hidden')
    )

    if (!currentTab) return
    
    const sourceValues = {
      loop_duration: currentTab.querySelector('[name*="ad_booker_loop_duration"]').value,
      price: currentTab.querySelector('[name*="ad_booker_price"]').value,
      currency: currentTab.querySelector('[name*="ad_booker_currency"]').value,
      impressions: currentTab.querySelector('[name*="ad_booker_impressions"]').value
    }
    
    this.tabTargets.forEach(tab => {
      if (tab === currentTab) return
      
      tab.querySelector('[name*="ad_booker_loop_duration"]').value = sourceValues.loop_duration
      tab.querySelector('[name*="ad_booker_price"]').value = sourceValues.price
      tab.querySelector('[name*="ad_booker_currency"]').value = sourceValues.currency
      tab.querySelector('[name*="ad_booker_impressions"]').value = sourceValues.impressions
    })
  }
}